import { Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AlertController } from "ionic-angular";
import { NavController, NavParams } from "ionic-angular";
import { Member } from "../../models/interfaces/member.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { ConfigService } from "../../providers/dbservice/configservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

import { ViewController } from "ionic-angular";

@Component({
  selector: "listcomponent",
  templateUrl: "listcomponent.html"
})
export class ListComponent {
  private selectedMember: Member[] = [];
  private member: any;
  private member_All = [];
  private member_by_status = [];
  private tmpSearchObject_by_status = [];
  private tmpSearchObject;
  private distinct_status = [];
  private listForm: FormGroup;
  private sel = [];
  private st_id: number;
  private type;
  private segmember: string = "Regular";
  private styleName: string ="";

  constructor(public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, public alertCtrl: AlertController,
    private db: DbserviceProvider, public viewCtrl: ViewController,
    private configService: ConfigService) {
    console.log("ListComponent constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    let tmp: string = this.navParams.get("sel");
    if (tmp !== undefined) {
      this.sel = tmp.split(",");
    }
    this.type = this.navParams.get("type");
    let mbrDefault = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY");
    let mbrDefaultOrder = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY_ORDER");

    this.db.dbCol({
      "action": "select", "mapObject": "vw_member",
      "sqlExtended": "  order by st_order, mb_hashname "
    }).subscribe((el) => {
      this.st_id = el[0].st_id;

      this.member_All = el;
      this.distinct_status = this.member_All.reduce((prev, { st_id, st_name }) =>
        prev.some(x => x.st_id === st_id && x.st_name === st_name) ? prev : [...prev, { st_id, st_name }], [])
      this.distinct_status.push()
      this.distinct_status.push({
        st_id: 99,
        st_name: 'All Members',
      });
      this.distinct_status.forEach((element, index, array) => {

        if (element.st_id == 99) {
          this.member_by_status[element.st_id] = this.member_All;

        } else {
          this.member_by_status[element.st_id] = this.member_All.filter(data => data.st_name == element.st_name);
        }
        // The tmp object contains all elements, this is used to reset during search
        this.tmpSearchObject_by_status[element.st_id] = this.member_by_status[element.st_id];
      });
      this.member = this.member_by_status[this.st_id];
      
    });
    this.tmpSearchObject = this.member;

    this.db.dbCol({
      "action": "select", "mapObject": "member",
      "sqlExtended": " where member.st_id<='" + mbrDefault + "' order by " + mbrDefaultOrder
    })
      .subscribe((el) => {
        el.map((mbr) => {
          this.sel.forEach((s) => {
            if (s === mbr.mb_hashname) {
              this.selectedMember.push(mbr);
            }
          });
        });
      });
    this.listForm = this.formBuilder.group({
    });
  }
  private addSelection(member: Member) {
    console.log("ListComponent addSelection");
    let index = this.selectedMember.findIndex((x) => x.mb_hashname === member.mb_hashname);

    if (this.selectedMember.length > 0 && this.type === "S") {/*S stands for single selection .Multiples not allowed*/
      let alert = this.alertCtrl.create({
        "buttons": [
          {
            "role": "cancel",
            "text": "Ok",
          }],
        "message": "You can only select one Hashman",
      });
      alert.present();
    }
    else {
      if (index === -1) {
        this.selectedMember.push(member);
      }
    }
  }

  private viewMemberStatus(memberStatus: number) {
    console.log("HareComponent viewMemberStatus");
    this.st_id = memberStatus;
    if (this.st_id == 99) {
      this.member = this.member_All;

    } else {
      this.member = this.member_All.filter(data => data.st_id == this.st_id);
    }
    // The tmp object contains all elements, this is used to reset during search
    this.tmpSearchObject_by_status[this.st_id] = this.member;
    //this.onInitPage();
  }

  private goback() {
    this.navCtrl.pop();
  }

  private addSelected() {
    console.log("ListComponent addSelected");
    this.viewCtrl.dismiss(this.selectedMember);
  }
  private deleteSelection(member: Member) {
    console.log("ListComponent deleteSelection");
    this.selectedMember = this.selectedMember.filter((el) => member.mb_hashname != el.mb_hashname);
  }

  private search(searchbar, status) {
    console.log("ListComponent search");
    let q = searchbar.target.value;
    
    // reset any pre-filtered values
    
    this.member_by_status[status] = this.tmpSearchObject_by_status[status];

    if (q.trim() === "") {
      this.member_by_status[status] = this.tmpSearchObject_by_status[status];
      return;
    }

    this.member_by_status[status] = this.member_by_status[status].filter((arrayEl) =>
      (arrayEl.mb_hashname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_firstname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_lastname.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.mb_birthdate.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
      (arrayEl.st_name.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1),
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listcomponent/listcomponent.ts